import React from 'react';
import './Laurels.css';

function Laurels() {
  return <div>Laurels</div>;
}

export default Laurels;
